export const FEATURE_NAME = '@zerops/zui/http-routing-fields';
